// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "hot-card-body{flex:1 1 auto;padding:1rem;padding:var(--card-padding)}", "",{"version":3,"sources":["webpack://./../../node_modules/@hotmart/cosmos/dist/card/card-body.css"],"names":[],"mappings":"AAAA,cAAc,aAAa,CAAC,YAAY,CAAC,2BAA2B","sourcesContent":["hot-card-body{flex:1 1 auto;padding:1rem;padding:var(--card-padding)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
